import React from 'react';
import * as IMAGE from '../../lib/image/event/EventGCCareImages';
import { getUserAgentValue } from '../../lib/util/UserAgent';

const { isMobile } = getUserAgentValue();

const TITLE_GC_CARE =
  '현대해상 굿앤굿 어린이보험 상담 신청 이벤트!';

export const ID_GC_CARE = 'gc-care';

export const PERIOD_GC_CARE = {
  startDate: '2023-03-06T00:00:00',
  endDate: '2023-03-31T00:00:00',
};

export const EVENT_HOME_BANNER_GC_CARE = {
  id: ID_GC_CARE,
  period: PERIOD_GC_CARE,
  image: IMAGE.HOME_BANNER_GC_CARE,
  url: isMobile ? 'https://shop.hi.co.kr/bin/MM/RR/CRMR0016G.jsp?param=E07&sc=TM&cg=MO' : 'https://shop.hi.co.kr/bin/MM/RR/CRMR0019G.jsp?param=E07&sc=TM&cg=PC',
};
